import { FC, ReactNode } from 'react'

import { EmployeeAvatar, EmployeeAvatarType } from './Avatar'

export const Employee: FC & EmployeeAvatarType = (): ReactNode => <></>

Employee.Avatar = EmployeeAvatar
